import React from 'react';
import { shape, string } from 'prop-types';

// Components
import { Box } from '@mui/material';
import BlockRoundedIcon from '@mui/icons-material/BlockRounded';

const NoneAvailableMessage = ({ bgColor, color, iconColor, message }) => (
  <Box
    alignItems="center"
    bgcolor={bgColor || 'graphic.lighter'}
    borderRadius="4px"
    color={color || 'text.primary'}
    display="flex"
    height={86}
    justifyContent="center"
    mx={3}
    my={2}
    p={2}
  >
    <BlockRoundedIcon
      sx={{
        color: iconColor || 'graphic.main',
        mr: 2,
      }}
    />
    {message}
  </Box>
);

NoneAvailableMessage.propTypes = {
  bgColor: string,
  color: string,
  iconColor: string,
  message: shape({}).isRequired,
};

NoneAvailableMessage.defaultProps = {
  bgColor: '',
  color: '',
  iconColor: '',
};

export default NoneAvailableMessage;
